import React from "react";
import { observer } from "mobx-react";

// Translation
import translate from '../Translate.js';

// Helpers
import {confirm, parentHasClass} from '../../helpers/helpers'

// Dependencies
import { FeatureFlag } from "react-launch-darkly";

// Components
import RoomTooltip from '../Common/RoomTooltip';

// Icons
import * as icons from '../Icons/Icons';
import SplitButton from "../Common/SplitButton";

const HybridRooms = observer(
    class HybridRooms extends React.Component {
        constructor() {
            super();

            // Set the initial state
            this.state = {
                showProctorDetails: null,
                selectedDropdownLocation: 'Default',
                showLocationDropdown: true
            };
            this.hideDropdown = this.hideDropdown.bind(this);
        }

        componentDidMount() {
            const { HybridStore } = this.props.store;
            HybridStore.setFocusedLocation('Default')
            HybridStore.listAvailableRooms(this.hideDropdown);
            document.addEventListener('click', this.hideProctorList);
        }

        hideDropdown() {
            this.setState({
                showLocationDropdown: false
            });
        }

        componentWillUnmount() {
            document.removeEventListener('click', this.hideProctorList);
        }

        /**
         * Hide any visible proctor lists
         *
         * @function hideProctorList
         * @param {event} e
         */
        hideProctorList = e => {
            const { classList } = e.target;

            if(
                !classList.contains('proctor-list') &&
                !classList.contains('room__show-proctors') &&
                !parentHasClass(e.target, 'proctor-list')

            ) {
                this.setState({ showProctorDetails: null });
            }
        }

        /**
         * Delete selected proctor room
         *
         * @function deleteProctorRoom
         */
        deleteProctorRoom(roomSid) {
            const { store, translation } = this.props;
            const { HybridStore } = store;

            const callback = () => {
                HybridStore.deleteProctorRoom(roomSid);
            }

            const msg = {
                heading: translation.delete_confirm.heading,
                body: translation.delete_confirm.body,
                button: translation.delete_confirm.button,
                cancel: translation.delete_confirm.cancel
            }

            confirm(msg, callback);
        }

        editProctorRoom(roomDetails) {
            const { setCreateNew, store } = this.props;
            const { HybridStore } = store;

            HybridStore.startEditing(roomDetails);
            setCreateNew(true);
        }

        selectProctorLocationInput(e) {
            this.props.store.HybridStore.setFocusedLocation(e.target.value);
            this.setState({ selectedDropdownLocation: e.target.value });
        }

        renderProctorLocationDropdown(locations) {
            const { translation } = this.props;
            const optionsElement = [
                <option value={'Default'} key={'Default'}>{translation.location_dropdown_instructions}</option>
            ];
            locations.map(location => {
                optionsElement.push(<option value={location.proctorAccountLocationSid} key={location.proctorAccountLocationSid}>{location.locationName || location.proctorAccountLocationSid}</option>);
                return true;
            });
            return (optionsElement);
        }

        renderBothButtons(room) {
            const { translation } = this.props;
            const {HybridStore} = this.props.store;
            const defaultAction = () => HybridStore.joinHybridProctoringRoom(room.sid);
            const buttonOptions = [
                {
                    title: translation.join_room,
                    onClick: () => HybridStore.joinHybridProctoringRoom(room.sid)
                },
                {
                    title: translation.join_room_beta,
                    onClick: () => HybridStore.joinHybridProctoringRoom(room.sid, true)
                }
            ];
            return (
                <SplitButton
                    onClick={defaultAction}
                    text={translation.join_room}
                    {...this.props}
                    options={buttonOptions}
                />
            );
        }

        renderHybridButton(room) {
            const { translation } = this.props;
            const {HybridStore} = this.props.store;
            return (
                <button
                    className="btn btn--outline"
                    onClick={() => HybridStore.joinHybridProctoringRoom(room.sid)}
                >
                    {translation.join_room}
                </button>
            );
        }

        render() {
            const { translation, setCreateNew } = this.props;
            const { showProctorDetails, selectedDropdownLocation, showLocationDropdown } = this.state;
            const {HybridStore} = this.props.store;
            const {availableRooms, proctorLocations} = HybridStore;

            return (
                <main tabIndex="0" id="main-content" className="page">
                    <div className="wrap">
                        <header className="page__header">
                            <h1 className="page__title">{translation.heading}</h1>
                        </header>
                    </div>
                    <div className="hybrid-panel hybrid-panel--md hybrid-panel--solo">
                        <h2 className="hybrid-panel__title--lg">
                            {translation.start_proctoring}
                        </h2>

                        { showLocationDropdown &&
                            <label className="select__sp_proctor_locations" htmlFor="sp_proctor_locations_select">
                                <select onChange={(e) => {
                                    this.selectProctorLocationInput(e);
                                }} name="sp_proctor_locations_select" id="sp_proctor_locations_select">
                                    {this.renderProctorLocationDropdown(proctorLocations)}
                                </select>
                            </label>
                        }

                        {(selectedDropdownLocation !== 'Default' || !showLocationDropdown) &&
                            <div>
                                <p>{translation.body}</p>
                                {availableRooms.length > 0 && (
                                    <ul className="room-list">
                                    {availableRooms.map((room) => (
                                        (room.proctorAccountLocationSid === selectedDropdownLocation || !showLocationDropdown) &&
                                        <li key={room.sid}>
                                            <article
                                                className={`room${room.isActive === true ? ' room--online' : ' room--offline'}`}
                                            >
                                                <span
                                                    className={`room__status${room.isActive === true ? ' room__status--online' : ' room__status--offline'}`}
                                                >
                                                    <RoomTooltip
                                                        brief
                                                        content={room.isActive === true ? translation.online : translation.offline}
                                                        hideLabel
                                                        id={`room-${room.sid}-status`}
                                                        left
                                                    />
                                                </span>
                                                <div className="room__details">
                                                    <h3 className="room__title">
                                                        {room.roomName ? room.roomName : room.sid}
                                                    </h3>
                                                    <span>
                                                        {room.activeSessions === 1
                                                            ? translation.active_session
                                                            : translation.active_sessions.replace('%count%', room.activeSessions || 0)
                                                        }
                                                    </span>
                                                    {(!room.proctors || room.proctors.length === 0) &&
                                                        <span className="room__no-proctors">
                                                            {translation.proctors.replace('%count%', 0)}
                                                        </span>
                                                    }
                                                    {room.proctors && room.proctors.length > 0 &&
                                                        <div className="room__proctors">
                                                            <button
                                                                className="room__show-proctors btn--reset"
                                                                onClick={() => {
                                                                    if(showProctorDetails === room.sid) {
                                                                        this.setState({showProctorDetails: null})
                                                                    } else {
                                                                        this.setState({showProctorDetails: room.sid})
                                                                    }
                                                                }}
                                                            >
                                                                {room.proctors && room.proctors.length === 1
                                                                    ? translation.proctor
                                                                    : translation.proctors.replace('%count%', room.proctors.length || 0)
                                                                }
                                                            </button>
                                                            <ul
                                                                className={`proctor-list${showProctorDetails === room.sid 
                                                                    ? ' proctor-list--visible' 
                                                                    : ''
                                                                }`}
                                                            >
                                                                {room.proctors.map(
                                                                    (proctor, i) =>
                                                                        <li
                                                                            className="hybrid-icon--xs"
                                                                            key={i}
                                                                        >
                                                                            {room.ownerSid === room.proctors[i].proctorAccountUserSid &&
                                                                            <icons.iconCrown />
                                                                            }
                                                                            {`${room.proctors[i].firstName} ${room.proctors[i].lastName}`}
                                                                        </li>
                                                                )}
                                                            </ul>
                                                        </div>
                                                    }
                                                </div>
                                                <div className="room__join action">
                                                    <button
                                                        className="room__delete btn btn--ghost btn--inverse hybrid-icon--sm"
                                                        onClick={() => this.editProctorRoom(room)}
                                                    >
                                                        <icons.iconEdit />
                                                        <span className="meta">{translation.edit_room}</span>
                                                    </button>

                                                    {!room.isActive && room.activeSessions === 0 &&
                                                    <button
                                                        className="room__delete btn btn--ghost btn--destructive hybrid-icon--sm"
                                                        onClick={() => this.deleteProctorRoom(room.sid)}
                                                    >
                                                        <icons.iconTrash2 />
                                                        <span className="meta">{translation.delete_room}</span>
                                                    </button>
                                                    }

                                                    <FeatureFlag
                                                        flagKey="allow-hybrid-beta-use"
                                                        renderFeatureCallback={() => this.renderBothButtons(room)}
                                                        renderDefaultCallback={() => this.renderHybridButton(room)}
                                                    />
                                                </div>
                                            </article>
                                        </li>
                                    ))}
                                    </ul>
                                )}
                                <button
                                    className="btn"
                                    onClick={() => setCreateNew(true)}
                                    type="button"
                                >
                                    <icons.iconPlus />
                                    {translation.create_room}
                                </button>
                            </div>
                        }
                    </div>
                </main>
            );
        }
    }
);

export default translate("HybridRooms")(HybridRooms);



// WEBPACK FOOTER //
// ./src/app/components/Hybrid/HybridRooms.js